import { useState } from "react";
import { Label, Input } from "@tellescope/design-system";
import { Popover, PopoverTrigger, PopoverContent, HexColorPicker, Button } from "@tellescope/ui";
import { X } from "lucide-react";

interface ColorFieldProps {
  label: string;
  value: string | undefined;
  onChange: (color: string | undefined) => void;
}

export const ColorField = ({ label, value, onChange }: ColorFieldProps) => {
  const [inputValue, setInputValue] = useState(value ?? "");

  return (
    <div className="space-y-1">
      <Label className="text-xs">{label}</Label>
      <div className="flex items-center gap-2">
        <Popover>
          <PopoverTrigger asChild>
            <button
              type="button"
              className="h-8 w-8 rounded border border-input shadow-sm cursor-pointer hover:ring-2 hover:ring-ring hover:ring-offset-1 transition-all flex-shrink-0"
              style={{ backgroundColor: value ?? "#ffffff" }}
              aria-label={label}
            />
          </PopoverTrigger>
          <PopoverContent className="w-auto p-3" align="start">
            <HexColorPicker
              color={value ?? "#ffffff"}
              onChange={(color) => {
                setInputValue(color);
                onChange(color);
              }}
            />
          </PopoverContent>
        </Popover>
        <Input
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={(e) => {
            const v = e.target.value;
            if (v.match(/^#[0-9A-Fa-f]{6}$/)) {
              onChange(v);
            } else {
              setInputValue(value ?? "");
            }
          }}
          placeholder="#000000"
          className="w-24 font-mono text-xs h-8"
        />
        {value && (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => {
              setInputValue("");
              onChange(undefined);
            }}
            className="h-7 w-7 p-0"
          >
            <X className="h-3 w-3" />
          </Button>
        )}
      </div>
    </div>
  );
};
